import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import { logUserIn, hideError } from '../actions/AuthActions'

const getHeader = () => {
  const header = localStorage.getItem('header')
  if (header && header !== 'null' && header !== 'undefined' && header !== '') {
    return header
  }
  return intl.get('Panel zwrotów i reklamacji')
}

const mapStateToProps = state => ({
  invalid: state.auth.invalid,
  error_message: state.auth.error_message,
  authenticated: !!(state.auth && state.auth.session && state.auth.session.token),
  url_order: state.router.location.query.order || false,
  url_token: state.router.location.query.token || false,
  lang: state.auth.lang
})

const mapDispatchToProps = dispatch => ({
    logInAction: (order_name, token) => dispatch(
      logUserIn(order_name, token)
    ),
    hideErrorAction: () => dispatch(hideError())
})

class LoginFormComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      order_name: '',
      token: '',
    }
  }

  componentDidMount = () => {
    const {
      authenticated,
      url_order,
      url_token,
      logInAction
    } = this.props
    if(!authenticated && url_order && url_token){
      logInAction(url_order, url_token)
    }
  }

  handleChange = (event) => {
    const {hideErrorAction} = this.props
    const {target} = event
    this.setState({
      [target.name]: target.value
    })
    hideErrorAction()
  }

  handleSubmit = (event) => {
    const {order_name, token} = this.state
    const {logInAction} = this.props
    event.preventDefault()
    logInAction(order_name, token)
  }

  render() {
    const {
      authenticated,
      invalid,
      error_message
    } = this.props
    const {
      order_name,
      token
    } = this.state
    return (
      <div className="center_wrapper">
        { !authenticated ? (
          <div className="login_form">
            <form onSubmit={this.handleSubmit}>
              <h2>{getHeader()}</h2>
              <div className="field">
                <input
                  placeholder=" "
                  name="order_name"
                  id="f-order_name"
                  type="text"
                  value={order_name}
                  onChange={this.handleChange} />
                <label htmlFor="f-order_name">{intl.get('Numer zamówienia')}</label>
              </div>
              <div className="field">
                <input
                  placeholder=" "
                  name="token"
                  id="f-token"
                  type="text"
                  value={token}
                  onChange={this.handleChange} />
                <label htmlFor="f-token">{intl.get('Token lub imię i nazwisko lub email')}</label>
              </div>
              <input type="submit" value={intl.get('OK')} />
              { invalid &&
                <div className="login-failed">
                  { error_message || (!token && intl.get('Pole Token jest wymagane')) || intl.get('Nie znaleziono zamówienia')}
                </div>
              }
            </form>
          </div>
        ) : (
          <Redirect to='/' />
        )}
      </div>
    )
  }
}
const LoginForm = connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent)
export default withRouter(LoginForm)
